<template>
  <div>
    <div class="breadcrumb_section bg_gray page-title-mini">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="page-title">
              <h1>{{ category.name }}</h1>
            </div>
          </div>
          <div class="col-md-6">
            <ol class="breadcrumb justify-content-md-end">
              <li class="breadcrumb-item"><a :href="route('home',{ domain : website.domain } )">Home</a></li>
              <li class="breadcrumb-item active">{{ category.name }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="main_content">

      <div class="container pt-5" v-if="(category.shop_extras.length >0) && category.shop_extras[0].value">
        <div class="card bg_light_blue" v-if="category.shop_extras[0].value">
          <div class="card-body">
            <p style="margin: 0;" class="card-title"><b>Thông tin</b></p>
            <div :style="{height: (expand_descript == true ? 'auto' : '100px')}" class="overflow-hidden" v-html="category.shop_extras[0].value"></div>
          </div>
          <div class="card-footer text-center" style="cursor: pointer;">
            <span class="text-primary h5" style="cursor: pointer;" v-if="!expand_descript" @click="expand_descript = true">Xem thêm <i class="linearicons-chevron-down"></i></span>
            <span class="text-primary h5" style="cursor: pointer;" v-if="expand_descript" @click="expand_descript = false">Thu gọn <i class="linearicons-chevron-up"></i></span>
          </div>
      </div>
      </div>
      <div class="container pt-5" v-else-if="category.description">
        <div class="row rounded bg_light_blue p-3">
          <h3>Thông tin: </h3>
          <div v-html="category.description"></div>
        </div>
      </div>

      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="row align-items-center mb-4 pb-1">
                <div class="col-12">
                  <div class="product_header">
                    <div class="product_header_left">
                      <div class="row mt-3 mb-4">
                        <div class="col-md-4">
                          <select v-model="price_selected" class="form-control" @change="handlePaginate(1)">
                            <option v-for="option in price_options" :value="option.value" :key="option.value">
                              {{ option.text }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-4">
                          <select v-model="rank_selected" class="form-control" @change="handlePaginate(1)"
                                  v-if="category.type === categoryTypes.FPS">
                            <option v-for="option in rank_fps" :value="option.slug" :key="option.id">
                              {{ option.fps }}
                            </option>
                          </select>
                          <select v-model="rank_selected" class="form-control" @change="handlePaginate(1)"
                                  v-if="category.type === categoryTypes.MOBA">
                            <option v-for="option in rank_moba" :value="option.slug" :key="option.id">
                              {{ option.moba }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-4">
                          <vue-typeahead-bootstrap
                              :data="skinList"
                              :min-matching-chars="1"
                              @hit="skin_selected = $event"
                              placeholder="Tìm skin"
                              @change="handlePaginate(1)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="product_header_right">
                      <button class="btn btn-block btn-warning" @click="clearFilter">Xoá lọc</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row shop_container" v-if="accountDataSet.data.length > 0" >
                <div class="col-lg-3 col-md-4 col-6 grid_item" v-for="account in accountDataSet.data" :key="account.id"
                     :id="account.id">
                  <div class="product_box  text-center">
                    <span class="pl_flash">Acc #{{ account.id }}</span>
                    <span v-if="account.is_fake_sale === 'on'" class="pr_flash">Nick Siêu Sale</span>
                    <div class="product_img">
                      <a :href="route('fe_viewacc', { domain: website.domain, id: account.id} )" target="_blank">
                        <img :src="account.thumbnail"
                             :alt="'Account '+ category.name + ' #' +account.id">
                      </a>
                      <div class="product_action_box">
                        <ul class="list_none pr_action_btn">
                          <li>
                            <button @click="buySubmit(account)" class="btn btn-buy-now btn-radius">Mua Ngay</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="product_info">
                      <h6 class="product_title">
                        <a :href="route('fe_viewacc', { domain: website.domain, id: account.id} )" target="_blank">
                          <strong class="col">Đăng ký: {{ loginTypes[account.login_type] }}</strong>
                          <strong class="col">Rank: <b v-if="category.type === categoryTypes.MOBA">{{
                              account.rank.moba
                            }}</b>
                            <b v-else>{{ account.rank.fps }}</b></strong>
                        </a>
                      </h6>
                      <div class="product_price text-center">
                        <span class="price text-success">ATM {{ Helper.formatMoney(account.atm_price)
                          }}<sup>đ</sup> </span><br><span class="price"> Card {{ Helper.formatMoney(account.price)
                        }}<sup>đ</sup></span>
                        <del v-if="account.old_price > account.price">{{ Helper.formatMoney(account.old_price)
                          }}<sup>đ</sup></del>
                        <div class="on_sale" v-if="account.promo > 0">
                          <span>Giảm {{ account.promo }}% </span>
                        </div>
                      </div>
                      <div class="pr_desc">
                        <div class="row row-cols-2" v-if="category.type === categoryTypes.MOBA">
                          <p class="col">Tướng: <b>{{ account.owner_champions }}</b></p>
                          <p class="col">Skin: <b>{{ account.owner_skins }}</b></p>
                        </div>
                        <div class="row row-cols-2" v-if="category.type === categoryTypes.FPS">
                          <p class="col">Súng {{ account.owner_guns }}</p>
                          <p class="col">Skin {{ account.owner_skins }}</p>
                        </div>
                      </div>
                      <div class="add-to-cart">
                        <a class="btn btn-fill-out btn-radius"
                           :href="route('fe_viewacc', { domain: website.domain, id: account.id} )" target="_blank">Chi
                          tiết</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="pagination mt-3 justify-content-center pagination_style1">
                    <b-pagination
                        v-model="accountDataSet.current_page"
                        :total-rows="accountDataSet.total"
                        :per-page="accountDataSet.per_page"
                        first-number
                        last-number
                        page-class="mr-1"
                        next-class="mr-1"
                        prev-class="mr-1"
                        last-class="mr-1"
                        align="center"
                        @change="handlePaginate"
                    >
                      <template v-slot:page="{ page, active }" class="page-link">
                        <b v-if="active">{{ page }}</b>
                        <i v-else>{{ page }}</i>
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <buy-account-modal-v3
      :account="this.account"
      :user="this.user"
      :website="this.website"
      :current-wallet="currentWallet"
      @reload="handlePaginate(1)"
      v-if="user"
    >
    </buy-account-modal-v3>
  </div>
</template>
<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import BuyAccountModalV3 from "./BuyAccountModalV3.vue";
export default {
  components: {BuyAccountModalV3, VueTypeaheadBootstrap},
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    currentWallet: {
      Type: Array,
      default() {
        return [];
      }
    },
    category: {
      Type: Object,
      default() {
        return {};
      }
    },
    categoryTypes: {
      Type: Object,
      default() {
        return {};
      }
    },
    loginTypes: {
      Type: Object,
      default() {
        return {};
      }
    },
    ranks: {
      Type: Object,
      default() {
        return {};
      }
    },
    accounts: {
      Type: Object,
      data() {
        return {}
      }
    },
    website: {
      Type: Object,
      data() {
        return {}
      }
    }
  },
  data() {
    return {
      accountDataSet: this._.clone(this.accounts),
      rank_fps: {},
      rank_moba: {},
      price_selected: 'all',
      rank_selected: 'all',
      skin_selected:  'all',
      price_options: [
          {value: 'all', text: 'Lọc theo giá (Tất cả)'},
          {value: '0-50000', text: 'Từ 50k trở xuống'},
          {value: '50000-100000', text: 'Từ 50k đến 100k'},
          {value: '100000-300000', text: 'Từ 100k đến 300k'},
          {value: '300000-500000', text: 'Từ 300k đến 500k'},
          {value: '500000-700000', text: 'Từ 500k đến 700k'},
          {value: '700000-1000000', text: 'Từ 700k đến 1 Triệu'},
          {value: '1000000-2000000', text: 'Từ 1 Triệu đến 2 Triệu'},
          {value: '2000000-5000000', text: 'Từ 2 Triệu đến 5 Triệu'},
          {value: '5000000-10000000', text: 'Từ 5 Triệu đến 10 Triệu'},
          {value: '10000000-100000000', text: 'Từ 10 Triệu trở lên'},
      ],
      skinList: [],
      account: {},
      expand_descript: false,
    }
  },
  watch: {
    skin_selected: function() {
      this.handlePaginate(1)
    }
  },
  mounted() {
    this.initSkin();
    this.ranks.unshift({
      fps: "Lọc theo rank (tất cả)",
      moba: "Lọc theo rank (tất cả)",
      slug: 'all',
    });

    this.rank_moba = this._.filter(this.ranks, function (item) {
      return item.moba !== null
    });
    this.rank_fps = this._.filter(this.ranks, function (item) {
      return item.fps !== null
    });
  },
  methods: {
    clearFilter() {
      this.price_selected = 'all';
      this.skin_selected = 'all';
      this.rank_selected = 'all',
          this.handlePaginate(1);
    },
    async initSkin(){
      const uri = this.route('home', {domain: this.website.domain}) + 'assets/js/skins.json';
      let response = await this.Request.get(uri);

      this.skinList = this._.clone(response.data);
    },
    async handlePaginate(page) {
      let params = {
        price: this.price_selected,
        rank: this.rank_selected,
        skin: this.skin_selected,
        domain: this.website.domain,
        cat: this.category.slug
      };
      if (page > 1) {
        params.page = page;
      }
      const uri = this.route('fe_viewcat', params);
      let response = await this.Request.get(uri);
      this.accountDataSet = this._.clone(response.data);

      this.$scrollTo('#head_page', 200);
    },
    async handleBuyAccount(account_id) {
      try {
        const uri = this.route('fe_buy_account', {domain: this.website.domain});
        const response = await this.Request.post(uri, {id: account_id});
        console.log(response);
        if (response.data.status === false) {
          await this.$swal.fire({
            title: 'Có lỗi xảy ra!',
            text: response.data.message,
            icon: 'error'
          });
        } else {
          await this.$swal.fire({
                icon: 'success',
                title: 'Thành Công',
                html: response.data.message,
              }
          );
          this.handlePaginate(1);
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
    },
    buyAcc(account) {
      if (!this.user){
        this.$swal.fire({
              icon: 'error',
              title: 'Bạn chưa đăng nhập',
              html: 'Vui lòng đăng nhập trước!',
            }
        );
      }
      this.account = account;
      this.$bvModal.show('buyAccModal');
    },
  }
}
</script>

<style scoped>
.ribbon:nth-child(even) {
  margin-right: 4%;
}

@media (max-width: 500px) {
  .ribbon {
    width: 100%;
  }

  .ribbon:nth-child(even) {
    margin-right: 0%;
  }
}

.ribbon4 {
  position: absolute;
  padding: 8px 10px;
  background: #dc3545;
  box-shadow: -1px 2px 3px rgba(0, 0, 0, .3);
}

.ribbon4:before, .ribbon4:after {
  content: "";
  position: absolute;
}

.ribbon4:before {
  width: 7px;
  height: 100%;
  top: 0;
  left: -6.5px;
  padding: 0 0 7px;
  background: inherit;
  border-radius: 5px 0 0 5px;
}

.ribbon4:after {
  width: 5px;
  height: 5px;
  bottom: -5px;
  left: -4.5px;
  background: lightblue;
  border-radius: 5px 0 0 5px;
}
</style>
